import { preloadImage } from 'utils';
import { collectPrintUrls } from './collectPrintUrls';
import { toPrintSrc } from './toPrintSrc';

export async function loadImagesAndPrint(): Promise<void> {
  const printUrls = collectPrintUrls();

  await Promise.all(printUrls.map(url => preloadImage(url)));

  // Snapshot, swap to full-res, print, then restore — so responsive image selection
  // (srcset) is preserved if the user cancels the print dialog and stays on the page.
  // <picture> imgs are excluded — the browser already displays the correct source.
  const snapshots = Array.from(document.querySelectorAll<HTMLImageElement>('main img:not(picture img)')).map(img => {
    const original = { src: img.src, srcset: img.srcset };
    img.src = toPrintSrc(img.src);
    img.srcset = '';

    return { img, original };
  });

  window.print();

  snapshots.forEach(({ img, original }) => {
    img.src = original.src;
    img.srcset = original.srcset;
  });
}
